import React from 'react';

export default function ReportClassification({accidentHistory}) {
  return(
    <div className="report-section">
      <h2>Accident Classification</h2>
      <p>
        P2PAUTO does not simply classify vehicles as
        "Accident" or "Non-Accident".
      </p>
      <p>
        We evaluate the extent of repairs and their impact
        on structural integrity.
      </p>
      <br />
      {(() => {
        switch (accidentHistory) {
          case 1:
            return <div style={{background:"green"}} className="grade">VERIFIED ACCIDENT-FREE VEHICLE</div>;
          case 2:
            return <div style={{background:"#f59e0b"}} className="grade">VERIFIED MINOR ACCIDENT VEHICLE</div>;
          case 3:
            return <div style={{background:"red"}} className="grade">VERIFIED MAJOR/MEDIUM ACCIDENT VEHICLE</div>;
          case 4:
            return <div style={{background:"red"}} className="grade">VERIFIED MAJOR/MEDIUM ACCIDENT VEHICLE</div>;
          default:
            return <div style={{background:"green"}} className="grade">VERIFIED ACCIDENT-FREE VEHICLE</div>;
        }
      })()}
    </div>
  )
}

